import { c as _c } from "react/compiler-runtime";
import { CreateGroup } from "@components/groups/create-group";
import { ViewModeSelector } from "@components/view-mode-selector/view-mode-selector";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
/**
 * The action buttons to be shown in the groups page
 */
export function GroupsActionButtons(t0) {
  const $ = _c(6);
  const {
    groups
  } = t0;
  const {
    canCreateGroups
  } = useHasUserValidRoleCompanyLevel();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ViewModeSelector subject="groups" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== canCreateGroups || $[2] !== groups) {
    t2 = canCreateGroups && <CreateGroup groups={groups} />;
    $[1] = canCreateGroups;
    $[2] = groups;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}